import { useState, useRef } from 'react';
import classes from './CommercialLaundry.module.css';
import '../../index.css';
import { pageContentConstants } from '../../constants/PageContentConstants';
import { doc, COMMERCIAL_LAUNDRY_SHEET_ID, CLIENT_EMAIL, PRIVATE_KEY, getCurrentDate, getCurrentDay,
    adoc, A_COMMERCIAL_LAUNDRY_SHEET_ID, A_CLIENT_EMAIL, A_PRIVATE_KEY
 } from '../../shared/gsheetConstants';
import $ from 'jquery';
import { Toast } from 'primereact/toast';
import CircularProgress from '@material-ui/core/CircularProgress';

const leftContainerInformation = pageContentConstants.COMMERCIAL_LAUNDRY_PAGE_CONTENT.INFO_CONTAINER.DETAILS;
const formFields = pageContentConstants.COMMERCIAL_LAUNDRY_PAGE_CONTENT.FORM_CONTAINER.FORM_INPUTS;
const stores = pageContentConstants.COMMERCIAL_LAUNDRY_PAGE_CONTENT.FORM_CONTAINER.STORES;

const CommercialLaundryPage = () => {
    const toast = useRef(null);
    const showToast = (severity, summary, detail) => {
        toast.current.show({ severity, summary, detail, life: 2000 });
    };

    const [isRequested, setIsRequested] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [yourName, setYourName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [address, setAddress] = useState('');
    const [store, setStore] = useState('Velachery');
    const [needs, setNeeds] = useState('');

    function getMethod (e, field) {
        switch(field) {
            case formFields[0]: 
                return setCompanyName(e.target.value);
            case formFields[1]: 
                return setYourName(e.target.value);
            case formFields[2]: 
                return setEmail(e.target.value);
            case formFields[3]: 
                return setPhone(e.target.value);
            case formFields[4]: 
                return setAddress(e.target.value);
            case "Laundry Needs": 
                return setNeeds(e.target.value);
            default:
                return;
        }
    }

    async function handleSubmit(event) {
        setIsRequested(true);
        event.preventDefault();
        const newEntry = { 
            Date: getCurrentDate(),
            Day: getCurrentDay(),
            CompanyName: companyName, 
            CustomerName: yourName , 
            Phone: phone, 
            Email: email, 
            Address: address,
            Needs: needs
        };
        await submitCommercialLaundryForm(newEntry);
    }

    async function submitCommercialLaundryForm (row) {
        try {
            const sheet = await createDocumentObjectByStoreLocation(store);
            await sheet.addRow(row);
            showToast('success', 'Success', 'Your request has been submitted.');
            setIsRequested(false);
            $("#commercialForm")[0].reset();
          } catch (e) {
            showToast('error', 'Error', 'Oops! Something went wrong.');
            setIsRequested(false);
          }
    }

    async function createDocumentObjectByStoreLocation(location) {
        try {
            if (location === 'Velachery') {
                await doc.useServiceAccountAuth({
                    client_email: CLIENT_EMAIL,
                    private_key: PRIVATE_KEY.replace(/\\n/g, '\n')
                    });
                    // loads document properties and worksheets
                    await doc.loadInfo();
                    const sheet = doc.sheetsById[COMMERCIAL_LAUNDRY_SHEET_ID];
                    return sheet;
                } else if (location === 'Anna Nagar') {
                    await adoc.useServiceAccountAuth({
                        client_email: A_CLIENT_EMAIL,
                        private_key: A_PRIVATE_KEY.replace(/\\n/g, '\n')
                    });
                    await adoc.loadInfo();
                    const sheet = adoc.sheetsById[A_COMMERCIAL_LAUNDRY_SHEET_ID];
                    return sheet;
                } else {
                    throw new Error("Invalid store location");
                }
        } catch (error) {
            throw new Error("Error creating document object: " + error.message);
        }
    }


    function checkIfEmail(field) {
        if (field === 'Email') {
            return true;
        }
        return false;
    }

    function checkIfPhone(field) {
        if (field === 'Phone Number') {
            return true;
        }
        return false;
    }

    return (
        <div className={classes.container}>
            <Toast ref={toast} position="top-right" />
            <div className={classes.full_width_container}>
                <div className={classes.top_info_container}>
                    <div className={[classes.container__title, "font_lg"].join(' ')}>
                        {pageContentConstants.COMMERCIAL_LAUNDRY_PAGE_CONTENT.TITLE}
                    </div>
                    <div className={[classes.container__description, "font_md"].join(' ')}>
                        {pageContentConstants.COMMERCIAL_LAUNDRY_PAGE_CONTENT.DESCRIPTION}
                    </div>
                    {/* <div className={[classes.container__card, "font_llg"].join(' ')}>
                        {pageContentConstants.COMMERCIAL_LAUNDRY_PAGE_CONTENT.CARD_CONTENT}
                    </div> */}
                    {/* <div className={classes.container__image}>
                        <img src={commercialLaundryImage} alt="commercial-laundry"/>
                    </div> */}
                </div>
            </div>

            <div className={classes.full_width_container}>
                <div className={classes.bottom_info_container}>
                    <div className={classes.left_container}>

                        {
                            leftContainerInformation.map((info, i) => {
                                return(
                                    <div key={i}>
                                        <div className={[classes.left_container__title, "font_lg"].join(' ')}>
                                            {info.title}
                                        </div>
                                        <div className={[classes.left_container__description, "font_md"].join(' ')}>
                                            {info.description}
                                        </div>
                                    </div>
                                )
                            })
                        }
                        
                    </div>
                    <div className={classes.right_container}>
                       <div className={[classes.right_container__title, "font_lg"].join(' ')}>
                            {pageContentConstants.COMMERCIAL_LAUNDRY_PAGE_CONTENT.TITLE}
                       </div>
                       <div className={classes.right_container__form}>
                            <form id="commercialForm" onSubmit={handleSubmit}>
                                {
                                    formFields.map((field, i) => {
                                        return (

                                            <div className={classes.form_input} key={i}>
                                                <label>{field}</label>
                                                {
                                                    checkIfEmail(field) ? 
                                                    <input type="email" id={field} name={field} onInput={ e=>getMethod(e, field)} required/> :
                                                    checkIfPhone(field) ?
                                                        <input type="text" 
                                                        maxLength="10"
                                                        pattern="\d*"
                                                        id={field} name={field} onInput={ e=>getMethod(e, field)} required/>
                                                        : <input type="text" id={field} name={field} onInput={ e=>getMethod(e, field)} required/>
                                                }
                                            </div>

                                        );
                                    })
                                }
                                <div className={classes.form_input}>
                                    <label>Preferred Store</label>
                                    <select className={classes.form_input} id="store" value={store} 
                                    onChange={(e) => setStore(e.target.value)} required>
                                        {stores.map((store, idx) => (
                                            <option key={idx} value={store}>   
                                                {store}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className={classes.right_container__form__textArea}>
                                    <label>Tell us about your laundry needs</label>
                                    <textarea rows="4"
                                    onInput={ e=>getMethod(e, "Laundry Needs")} required>
                                    </textarea>
                                </div>
                                <div className={classes.button_container}>
                                    <button className="button_variant_3"
                                    disabled={isRequested} 
                                    type="submit">
                                        {
                                            isRequested ? <CircularProgress size={24} /> : 'SUBMIT'
                                        }
                                    </button>
                                </div>
                            </form>
                       </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CommercialLaundryPage;